/**
 * Labstep
 *
 * @module components/OrderRequest/Form/ShowEdit/Amount
 * @desc ShowEdit form for order request amount
 */

import { fieldOrderRequestAmount } from 'labstep-web/components/OrderRequest/Form/fields';
import { FormShowEditAmount as ShowEditAmount } from 'labstep-web/core/Form/ShowEdit/Amount';
import { CurrencyService } from 'labstep-web/services/currency.service';
import type React from 'react';
import type { OrderRequestFormShowEditAmountProps } from './types';

export const OrderRequestFormShowEditAmount: React.FC<
  OrderRequestFormShowEditAmountProps
> = ({ orderRequest, withCurrency }) => (
  <ShowEditAmount
    dataCy="components/OrderRequest/Form/ShowEdit/Amount"
    currency={orderRequest.currency}
    entity={orderRequest}
    entityName={orderRequest.entityName}
    field={fieldOrderRequestAmount}
  >
    {orderRequest.amount && withCurrency
      ? CurrencyService.print(
          orderRequest.amount,
          orderRequest.currency,
          true,
        )
      : CurrencyService.getPrice(
          orderRequest.amount,
          orderRequest.currency,
          true,
        )}
  </ShowEditAmount>
);
